import React from 'react'
import { Link } from 'react-router-dom'
import {
  IonImg
} from '@ionic/react'
import './styles.scss'

export const NewsRadioCard = (props) => {
  const { content } = props
  const url = `https://yokradio.com/leer/${content.id}_${content.url_title}`
  return (
    <figure className='news-radio-card' itemScope itemType='http://schema.org/NewsArticle'>

      <meta itemProp='url' content={url} />

      <div itemProp='image' itemScope itemType='http://schema.org/ImageObject'>
        <meta itemProp='height' content={content.miniature_height} />
        <meta itemProp='width' content={content.miniature_width} />
        <meta itemProp='url' content={content.miniature} />
        <Link
          className='title'
          to={`/leer/${content.id}_${content.url_title}`}
          aria-label={`Leer ${content.title}`}
          itemProp='headline'
        >
          <IonImg
            src={content.miniature}
            alt={`Foto: ${content.title}`}
            width='300'
            height='170px'
          />
        </Link>
      </div>

      <figcaption>
        <Link
          className='title'
          to={`/leer/${content.id}_${content.url_title}`}
          aria-label={`Leer ${content.title}`}
          itemProp='headline'
        >
          {content.title}
        </Link>
        <meta itemProp='description' content={content.intro} />
        <meta itemProp='author' content={content.editor_name} />
        <meta itemProp='datePublished' content={content.date} />
      </figcaption>

      <section itemProp='publisher' itemScope itemType='http://schema.org/Organization'>
        <meta itemProp='url' content='https://yokradio.com/' />
        <meta itemProp='name' content='Yok Radio' />
        <div itemProp='logo' itemScope itemType='http://schema.org/ImageObject'>
          <meta itemProp='url' content='https://yokradio.com/assets/icon/android-chrome-1024x1024.png' />
        </div>
      </section>

    </figure>
  )
}
